$(document).on('ready', function () {
    var $slides = $('div[data-section-type="webshop-slideshow-section"]');
    if ($slides.length > 0) {
        $.each($slides, function (index, $element) {
            var slideContainer = $($element).find('.swiper-container');
            var config = {};
            var show_overlay = slideContainer.data('show_overlay');
            var show_arrow = slideContainer.data('show_arrow');
            var swiper_autoplay = slideContainer.data('swiper_autoplay');
            if (show_overlay) {
                config["pagination"] = {
                    el: '.swiper-pagination',
                    clickable: false,
                }
            }
            if (show_arrow) {
                config["navigation"] = {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                }
            }
            if(1 == 2 && swiper_autoplay) {
                config['autoplay'] = {
                    delay: parseInt(swiper_autoplay)
                }
            }
            new Swiper(slideContainer,config);
        });
    }
});